import React, { useState, CSSProperties, memo, useCallback } from "react";
import { RiPencilFill } from "react-icons/ri";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../../../Component/BasicComponents/BasicDataTable";
import { FaEdit, FaPlus } from "react-icons/fa";
import AddressModal from "../Modal/AddressModal";
import { useGetOutletAddressList } from "../hooks/useCustomer";

interface TableButtonProps {
  onClick: () => void;
  title?: string;
  style?: CSSProperties;
}

const TableButton: React.FC<TableButtonProps> = memo(
  ({ onClick, title = "Add Heads", style }) => {
    const defaultStyle: CSSProperties = {
      display: "flex",
      borderRadius: "20px",
      padding: "2px",
      width: "110px",
      height: "40px",
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
    };

    return (
      <div>
        <button
          onClick={onClick}
          className="btn btn-info"
          style={{ ...defaultStyle, ...style }} // External styles override default
        >
          <FaPlus /> <span style={{ marginLeft: "5px" }}>{title}</span>
        </button>
      </div>
    );
  }
);

const TableColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Address Name",
    selector: (row: { AddressName: string }) => row.AddressName,
  },
  {
    name: "Outlet Address",
    selector: (row: { OutletAddress: string }) => row.OutletAddress,
  },
  {
    name: "Outlet Street Name",
    selector: (row: { OutletStreetName: string }) => row.OutletStreetName,
  },
  {
    name: "Outlet City",
    selector: (row: { OutletCity: string }) => row.OutletCity,
  },

  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-primary"
          onClick={() => handleEdit(row)}
          style={{ borderRadius: "20px", padding: "2px", width: "80px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];

const AddressTable = ({ OutletId }: any) => {
  const [isModal, setIsModal] = useState(false);
  const [mode, setmode] = useState<"add" | "edit">("add");
  const [selectedRow, setSelectedRow] = useState();
    const [pageState, setPageState] = useState({
    page: 1,
  });
  const [limitState, setLimitState] = useState({
    limit: 10,
  });
  const [search,setSearch]=useState({
    searchValue:''
  })
  const { data: addressList } = useGetOutletAddressList({
    outletId: OutletId,
    params: {
      page: pageState.page,
      limit: limitState.limit,
      search:search.searchValue

    },
    enabled: !!OutletId,
  });

  const handleEdit = (row: any) => {
    setIsModal(true);
    setmode("edit");
    setSelectedRow(row);
  };

  const toggle = () => {
    setIsModal(!isModal);
  };

  const handleAddAddress = useCallback(() => {
    setIsModal(true);
    setmode("add");
  }, []);

  const oncloseModal = () => {
    setIsModal(false);
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
 
      };
  });
      setLimitState((prevState: any) => {
        return {
          ...prevState,
          limit: limit,
        };
      });
    
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  }

   const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  }

  return (
    <>
      <BasicDataTable
        paginationTotalRows={addressList?.data?.Pagination?.TotalAddresses}
        Title="Address"
          onChangePage={(pageNo: number) => {
             handlePagination(pageNo);
           }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
           handleonChangeRowsPerPage(newPerPage, page);
         }}
            handleSearch={(val: any) => {
          handleSearch(val);
        }}
        columns={TableColumns(handleEdit)}
        data={addressList?.data?.OutletAddresses || []}
        headerContent={
          <TableButton
            onClick={handleAddAddress}
            title="Add Address"
            style={{
              width: "fit-content",
              padding: "5px 5px",
              height: "30px",
              backgroundColor: "#2e8dd3",
            }}
          />
        }
      />
      <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isModal}
        title={mode == "add" ? "Add Address" : "Edit Address"}
        content={
          <AddressModal
            mode={mode}
            modalClose={oncloseModal}
            initialData={selectedRow}
            OutletId={OutletId}
          />
        }
      />
    </>
  );
};
export default AddressTable;
